import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (_error) {
    return { hasError: true }
  }

  render () {
    const { t } = this.props
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className='pt-5 static-root h-100 page-not-found bg-container' style={{ color: '#FFF' }}>
          <h2 className='text-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              fill='currentColor'
              className='w-4 h-4 mr-2'
              aria-hidden='true'
            >
              <path d='M12 2.5L1.5 21h21L12 2.5zm0 5.2 6.8 11.3H5.2L12 7.7zM11 10v5h2v-5h-2zm0 6.5v2h2v-2h-2z' />
            </svg>
            {t('error')}
          </h2>
          <div className='mt-3 notFound text-center'>
            <p>
              {t('somethingWentWrong')}
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorBoundary)
